// src/services/socket.ts
import io, { Socket } from "socket.io-client";
import { SOCKET_URL } from "./apiUrl";
import { debounce } from "throttle-debounce";
import * as batchActions from "../../store/batchSlice";
import * as progressActions from "../../store/progressSlice";
export let socket: Socket;

export const initialize = debounce(500, async () => {
  if (!socket) {
    const { store } = await import("../../store");
    socket = io(SOCKET_URL);

    socket.on("REFRESH_BATCHES", () => {
      console.log("Received REFRESH_BATCHES event");
      store.dispatch(batchActions.loadBatchesAsync({}) as any);
    });

    socket.on("SET_SJIT_ORDER_UPLOAD_PROGRESS", (data: any) => {
      console.log("Received SET_SJIT_ORDER_UPLOAD_PROGRESSS event");
      store.dispatch(progressActions.setSjitOrderUpload(data) as any);
    });

    socket.on("SET_SJIT_ORDER_PROCESS_PROGRESS", (data: any) => {
      console.log("Received SET_SJIT_ORDER_PROCESS_PROGRESS event");
      store.dispatch(progressActions.setSjitOrderProcess(data) as any);
    });

    socket.on("ROAS", (data: any) => {
      console.log("Received ROAS event");
      store.dispatch(progressActions.setRoas(data) as any);
    });
    socket.on("SJIT_INVENTORY", (data: any) => {
      console.log("Received SJIT_INVENTORY event");
      store.dispatch(progressActions.setSjitInventory(data) as any);
    });
    socket.on("SJIT_INVENTORY_PAYLOAD", (data: any) => {
      console.log("Received SJIT_INVENTORY_PAYLOAD event");
      store.dispatch(progressActions.setSjitInventoryPayload(data) as any);
    });
    socket.on("PING_WORKER", () => {
      console.log("Received PING_WORKER, sending PONG_WORKER");
      socket.emit("PONG_WORKER");
    });

    // --- MODIFIED TASK HANDLER ---
    socket.on("TASK", (data) => {
      const { workerDefinition, jobId, payload } = data;
      console.log("Received TASK event for job:", jobId);

      try {
        // 1. (FIXED) Create the Blob directly from the worker string.
        // Do NOT wrap it in an IIFE "()()".
        const blob = new Blob([workerDefinition], {
          type: "application/javascript",
        });
        const workerURL = URL.createObjectURL(blob);
        const worker = new Worker(workerURL);

        // 2. Set up error handling
        worker.onerror = (e) => {
          console.error(`Error in worker for job ${jobId}:`, e.message);
          // Send error back
          socket.emit("TASK_RESULT", {
            jobId,
            resultsBatch: [
              { status: "error", error: `Worker error: ${e.message}` },
            ],
          });
          worker.terminate();
          URL.revokeObjectURL(workerURL);
        };

        // 3. Set up success message handler
        worker.onmessage = (msg) => {
          console.log(`Task ${jobId} complete. Sending results to server.`);

          // 4. (FIXED) Emit 'TASK_RESULT' (not 'TASK_COMPLETE')
          // 5. (FIXED) Send payload as 'resultsBatch' (not 'result')
          socket.emit("TASK_RESULT", {
            jobId,
            resultsBatch: msg.data, // 'msg.data' is the results array from the worker
            socketId: socket.id,
          });

          // 6. Clean up
          worker.terminate();
          URL.revokeObjectURL(workerURL);
        };

        // 7. Start the worker
        worker.postMessage(payload); // 'payload' contains '{ payloadBatch }'
      } catch (err) {
        console.error(`Failed to create worker for job ${jobId}:`, err);
        socket.emit("TASK_RESULT", {
          jobId,
          resultsBatch: [
            { status: "error", error: `Client error: ${err.message}` },
          ],
        });
      }
    });

    socket.onAny((event, ...args) => {
      console.log(`Received ${event} event with data:`, args);
    });
  }
});

// This function isn't used by the TASK handler, but leaving it
function deserializeFunction(
  funcStr: string
): (...args: any[]) => Promise<any> | any {
  try {
    // eslint-disable-next-line no-new-func
    const func = new Function(`return (${funcStr})`)();
    return func;
  } catch (error) {
    console.error("Error deserializing worker function:", error);
    return () => Promise.reject(new Error("Invalid worker function."));
  }
}

export const terminate = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.close();
    socket = undefined;
  }
};

export const getSocket = () => {
  return socket;
};
